jQuery(document).on('ready', function () {
	jQuery('.home-slider').fadeIn(500)

	jQuery('.home-slider').each((index, gallery) => {
		import('slick-carousel').then(() => {
			jQuery(gallery).not('.slick-initialized').slick({
				prevArrow: '<button class="slick-prev slick-arrow"><span class="show-for-sr">Previous</span></button>',
				nextArrow: '<button class="slick-next slick-arrow"><span class="show-for-sr">Next</span></button>',
				infinite: false,
				autoplay: true,
				autoplaySpeed: 10000,
				adaptiveHeight: true,
			})
		})
	})
})
